import React from 'react';
import { FormattedMessage } from 'react-intl';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import TextBox from '../common/inputs/textBox';
import ErrorFeedback from '../common/feedback/errorFeedback';

const RequestResetPasswordPopup = props => {
  const {
    handleShowPopup,
    handleButton,
    loadingButton,
    statusButton,
    popupState,
    handleOnChangeResetPasswordForm,
    resetPasswordFormData
  } = props;  
  return (
    <GlassPopup 
      className="reset_password_popup"
      title={(<FormattedMessage id="login.requestResetPassword.title"/>)}
      buttonText={(<FormattedMessage id="login.requestResetPassword.action"/>)}
      {...props}
    >
      <p><FormattedMessage id="login.requestResetPassword.instructions"/></p>
      <TextBox
        styleType={Constants.interface.inputs.styleType.STANDARD}
        type={Constants.interface.inputs.type.EMAIL}
        id="recover_email"
        value={resetPasswordFormData.recover_email}
        onChange={handleOnChangeResetPasswordForm}
        onKeyEnter={handleButton}
        labelLocale={<FormattedMessage id="common.email"/>}
      />
      <ErrorFeedback
        status={statusButton}
        optionalStatusErrors={{
          "422": <FormattedMessage id="login.requestResetPassword.errors.invalidEmail"/>
        }}
      />
    </GlassPopup>
  );
};

export default RequestResetPasswordPopup;



// WEBPACK FOOTER //
// ./source/client/components/login/requestResetPasswordPopup.jsx